import React, { useContext, useState } from 'react'
import { Alert } from 'components'
import { AutoComplete, Button } from 'components/Form'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { CreateBatteryStyles } from './Style'
import { updateVisibilityStatusFetch } from 'store/middlewares/assessment.crud'
import { AssessmentsContext } from './AssessmentsContext'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { visibilityStatuseOptions } from 'keys/visibilityStatuses'

const CreateBatteryAlert = (props) => {
    const { handleAlert = () => { } } = props
    const { setResetRowSelection, selectedAssessments, setSelectedAssessments, assessmentOptions } = useContext(AssessmentsContext)
    const queryClient = useQueryClient()

    const [status, setStatus] = useState(null)

    const { mutateAsync: updateVisibilityStatus, isPending } = useMutation({
        mutationFn: updateVisibilityStatusFetch,
        onSuccess: () => {
            handleAlert(false)
            setResetRowSelection(true)
            setSelectedAssessments(null)
            queryClient.invalidateQueries({ queryKey: assessmentOptions.queryKey })
            toast(" העדכון בוצע בהצלחה", toastConfig)
        }
    })

    const handleUpdateStatus = () => {
        updateVisibilityStatus({ visibility_status: status.id, assessment_ids: selectedAssessments })
    }

    return (
        <Alert
            systemUI
            title={"עדכון סטטוס "}
            footerActions={[]}
            handleAlert={() => handleAlert(false)}
            closeOnClick
        >
            <CreateBatteryStyles>
                <AutoComplete
                    input={{
                        value: status,
                        onChange: setStatus
                    }}
                    placeholder="בחר סטטוס"
                    options={visibilityStatuseOptions}
                />
                <div>
                    <Button
                        loading={isPending}
                        disabled={!status || isPending}
                        action={handleUpdateStatus}
                        color="thirdly"
                        label="עדכון סטטוס תצוגתי"
                    />
                </div>
            </CreateBatteryStyles>
        </Alert>
    )
}

export default CreateBatteryAlert